export type Success<T = void> = { resultType: 'Success'; data: T };
export type Failure<E extends Error = Error> = {
  resultType: 'Failure';
  error: E;
};
export type Result<T = void, E extends Error = Error> = Success<T> | Failure<E>;

export function isSuccess<T = void>(result: Result<T>): result is Success<T> {
  return result.resultType === 'Success';
}

export function isFailure<E extends Error = Error>(
  result: Result<unknown, E>
): result is Failure<E> {
  return result.resultType === 'Failure';
}

export function succeed<T = void>(data: T): Success<T> {
  return { data, resultType: 'Success' };
}

export function fail<E extends Error = Error>(error: E): Failure<E> {
  return { error, resultType: 'Failure' };
}
